import * as React from 'react';

export default ({middleSection, leftSection, rightSection}: HeaderProps) => (
   <div className="header-space-filler">
      <div className="header">
         <div className="header-section left-section">
            {leftSection}
         </div>
         <div className="header-section middle-section">
            {middleSection}
         </div>
         <div className="header-section right-section">
            {rightSection}
         </div>
      </div>
   </div>
);

export interface HeaderProps {
   leftSection?: JSX.Element;
   middleSection?: JSX.Element;
   rightSection?: JSX.Element;
}
